import Modal from "components/Modal/Modal";
import { toast } from "react-toastify";
import { useState } from "react";
import { IUserCreate } from "authentication/domain/IUserCreate";
import { useForm } from "react-hook-form";
import EmployeeSelectCustom from "./EmployeeSelectCustom";
import { authServices } from "authentication/services/auth.service";

interface IProps {
  setClickOutsideActive: Function;
  isOpen: boolean;
  refresh: Function;
  setIsOpen: Function;
}

const NewUserModal = ({
  setClickOutsideActive,
  isOpen,
  setIsOpen,
  refresh,
}: IProps) => {
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm<IUserCreate>();

  const close = () => {
    reset();
    setIsOpen(false);
    setClickOutsideActive(true);
  };

  const [employeeId, setEmployeeId] = useState(null);
  const [newFullName, setNewFullName] = useState(null);

  const createUser = async (data: IUserCreate) => {
    try {
      const submitData = { ...data, employeeId: employeeId, name: newFullName };
      await authServices.createUser(submitData);
      toast.success("Korisnik je uspešno kreiran.");
      close();
      refresh();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={close}
      onSubmit={handleSubmit(createUser)}
      title="Dodavanje novog korisnika"
    >
      <div>
        Ovde unosite novog korisnika u sistem. Ovo je obavezan korak u
        registraciji.
      </div>
      <div className="newUserContainer">
        <div className="newUserInputs">
          <div className="inputDiv">
            <label><b>ime</b></label>
            <EmployeeSelectCustom
              setEmployee={setEmployeeId}
              setNewFullName={setNewFullName}
              classes="dropdown"
            />
          </div>
          <div className="inputDiv">
            <label><b>korisničko ime</b></label>
            <input
              type="text"
              className={`inputField center
                ${errors.username ? "inputError" : ""}`}
              {...register("username", { required: true })}
            />
          </div>
          <div className="inputDiv">
            <label><b>lozinka</b></label>
            <input
              type="text"
              className={`inputField center
                ${errors.password ? "inputError" : ""}`}
              {...register("password", { required: true })}
            />
          </div>
        </div>
      </div>
    </Modal >
  );
};

export default NewUserModal;
